import React from 'react';
import { LoadingIcon, ScrollDiv } from '_components'
import { connect } from 'react-redux'
import styles from './List.module.css'
import { DiaryTasksListItem } from './ListItem';

class DiaryTasksList extends React.Component {

    render() {
        return (
            <div>
                {this.props.loading &&
                    <div className={styles.loading_container}>
                        <LoadingIcon size="small" />
                    </div>
                }
                <ScrollDiv divId={'MC_DIARY_ITEMS'} className={styles.message_list}>
                    {Object.keys(this.props.messages)
                        .map(key => {
                            const message = this.props.messages[key];
                            return <DiaryTasksListItem
                                key={message.dlno}
                                id={message.dlno}
                            />
                        })

                    }
                </ScrollDiv>
            </div>
        );
    }
}


function mapStateToProps(state) {
    let messages = Object.keys(state.entities.mcDiaryItems)
        .sort((a, b) =>
            new Date(state.entities.mcDiaryItems[a].dateAdded).getTime() - new Date(state.entities.mcDiaryItems[b].dateAdded).getTime()
        )
        .map(x => state.entities.mcDiaryItems[x]);

    return {
        messages,
        loading: state.ui.mcDiaryItems.loading
    };
}

const connectedDiaryTasksList = connect(mapStateToProps)(DiaryTasksList);
export { connectedDiaryTasksList as DiaryTasksList };